/* eslint-disable no-unused-vars */
/**
 * Constants
 */

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER_REGISTER: 'user_register',
  REFRESH_TOKEN: 'refresh_token',
  TOTAL_SERVICES: 'total_services',
};

export const HTTP_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNPROCESSABLE: 422,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

export const HTTP_METHOD = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  OPTIONS: 'OPTIONS',
  HEAD: 'HEAD',
};

export enum OptionBulkOperations {
  DEFAULT = 0,
  APPROVAL = 10,
  DISAPPROVAL = 20,
}

export const TIME_REFRESH_TOKEN = 180;

export const TIME_LOCKED = 5000;

export enum ParamsGetListSetting {
  ROW_PER_PAGE = 10,
  DEFAULT_PAGE = 1,
  LAST_FIRST_PER_PAGE = 5,
  ORDER_BY = 'desc',
}

export const MIN_ITEMS_ON_PAGE = 9;

export const TIME_AUTO_CLOSE_NOTIFY = 5000;

export const SSO_URL = {
  LOGIN: process.env.REACT_APP_SSO_LOGIN_URL || '',
  LOGOUT: process.env.REACT_APP_SSO_LOGOUT_URL || '',
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '',
};

export const AWS_S3 = {
  BASE_URL: process.env.REACT_APP_S3_URL || '',
  LOGO_PNG: `${process.env.REACT_APP_S3_URL}/system/logo.png` || '',
  LOGO_SVG: `${process.env.REACT_APP_S3_URL}/system/logo.svg` || '',
};

export const SYSTEM_MENU = {
  REGISTRANT_INFO: 'おもたす登録者情報',
  DOWNLOAD_SYSTEM_APPLICATION_SETTING_CHECK: '申請状況確認',
  DIGITAL_SURVEY: 'デジタルアンケート',
  PEOPLE_FLOW_MEASUREMENT: '人流計測',
  AUDIO_ANALYSIS: '音声解析',
  REQUEST_MATERIAL: '資料請求フォーム',
};

export enum StatusKey {
  NOT_USED = 'not-used',
  REQUESTED = 'requested',
  IN_USED = 'in-used',
  CANCELED = 'canceled',
  FINISHED = 'finished',
}

export const STATUS_SYSTEM_TEXT: Record<any, string> = {
  [StatusKey.NOT_USED]: '未申請',
  [StatusKey.REQUESTED]: '申請中',
  [StatusKey.IN_USED]: '承認済み',
  [StatusKey.CANCELED]: '非承認',
  [StatusKey.FINISHED]: '終了',
};

export const FORMAT_DATE = 'YYYY/MM/DD';

export const MAX_FILE_SIZE = 1048576; // 1MB

export const FILE_ALLOWED_FORMATS = ['image/png', 'image/svg', 'image/jpeg'];

export const CONTENT_TYPE = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
};

export const VALUE_MENU = {
  USER_INFO: 'user_info',
  SYSTEM_SETTING: 'system_setting',
  AUDIO_ANALYSIS: 'audio_analysis',
  DIGITAL_SURVEY: 'digital_survey',
  PEOPLE_MEASUREMENT: 'people_measurement',
  // DOCUMENT_REQUEST_FORM: 'document_request_form',
  APPLICATION_STATUS_CHECK: 'application_status_check',
} as const;

export const DEFAULT_DURATION = '00:00:00';

export const YES_TEXT = '有';

export const NO_TEXT = '無';
